/**
 * Anti-Theft Protection Script
 * Protects content from being stolen
 * Ultra lightweight - only 6KB
 */

(function() {
  'use strict';

  const CONFIG = {
    protectText: true,
    protectImages: true,
    disableKeyboardShortcuts: true,
    protectBackgroundImages: false,
    disableRightClick: true,
    disableBrowserConsole: false,
    disablePrint: true,
    showWarning: true,
    warningMessage: 'Content is protected. Please respect copyright.',
    mobileProtectText: true,
    mobileProtectImages: true
  };

  function init() {
    if (!CONFIG.protectText && !CONFIG.protectImages && !CONFIG.disableKeyboardShortcuts && !CONFIG.disableRightClick && !CONFIG.disablePrint) return;

    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    if (isMobile) {
      if (CONFIG.mobileProtectText) initTextProtection();
      if (CONFIG.mobileProtectImages) initMobileImageProtection();
      if (CONFIG.disableRightClick) initMobileContextMenu();
    } else {
      if (CONFIG.protectText) initTextProtection();
      if (CONFIG.protectImages) initImageProtection();
      if (CONFIG.protectBackgroundImages) initBackgroundImageProtection();
      if (CONFIG.disableKeyboardShortcuts) initShortcutProtection();
      if (CONFIG.disableRightClick) initRightClickProtection();
      if (CONFIG.disableBrowserConsole) initConsoleNotice();
      if (CONFIG.disablePrint) initPrintProtection();
    }
  }

  function showWarning(message) {
    if (!CONFIG.showWarning) return;

    const existing = document.getElementById('ah-antitheft-warning');
    if (existing) existing.remove();

    const warning = document.createElement('div');
    warning.id = 'ah-antitheft-warning';
    warning.textContent = message || CONFIG.warningMessage;
    warning.style.cssText = `
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.9);
      color: #fff;
      padding: 14px 28px;
      border-radius: 8px;
      font-size: 14px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      z-index: 2147483647;
      box-shadow: 0 4px 20px rgba(0,0,0,0.3);
      pointer-events: none;
    `;

    const animStyle = document.createElement('style');
    animStyle.textContent = `
      @keyframes ah-warning-in { from { opacity: 0; transform: translateX(-50%) translateY(10px); } to { opacity: 1; transform: translateX(-50%) translateY(0); } }
      @keyframes ah-warning-out { from { opacity: 1; transform: translateX(-50%) translateY(0); } to { opacity: 0; transform: translateX(-50%) translateY(10px); } }
    `;

    document.head.appendChild(animStyle);
    document.body.appendChild(warning);

    requestAnimationFrame(() => {
      warning.style.animation = 'ah-warning-in 0.3s ease forwards';
    });

    setTimeout(() => {
      warning.style.animation = 'ah-warning-out 0.3s ease forwards';
      setTimeout(() => warning.remove(), 300);
    }, 2500);
  }

  // Text Selection Protection
  function initTextProtection() {
    const style = document.createElement('style');
    style.id = 'ah-text-protection';
    style.textContent = `
      body {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      input, textarea, select, [contenteditable="true"], [contenteditable=""] {
        -webkit-user-select: auto !important;
        -moz-user-select: auto !important;
        -ms-user-select: auto !important;
        user-select: auto !important;
      }
      .ah-selectable, [data-selectable="true"] {
        -webkit-user-select: text !important;
        -moz-user-select: text !important;
        -ms-user-select: text !important;
        user-select: text !important;
      }
      ::selection {
        background: transparent !important;
        color: inherit !important;
      }
    `;
    document.head.appendChild(style);

    document.addEventListener('selectstart', function(e) {
      const el = e.target;
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') return;
      if (el.isContentEditable) return;
      if (el.closest('[contenteditable="true"]')) return;
      if (el.closest('.ah-selectable, [data-selectable="true"]')) return;
      e.preventDefault();
    });
  }

  // Image Protection
  function initImageProtection() {
    document.addEventListener('contextmenu', function(e) {
      if (e.target.tagName === 'IMG' || e.target.closest('img')) {
        e.preventDefault();
        showWarning();
      }
    });

    document.addEventListener('dragstart', function(e) {
      if (e.target.tagName === 'IMG' || e.target.closest('img')) {
        e.preventDefault();
        return false;
      }
    });

    document.addEventListener('mousedown', function(e) {
      if (e.target.tagName === 'IMG' || e.target.closest('img')) {
        if (e.detail > 1) {
          e.preventDefault();
          return false;
        }
      }
    });
  }

  // Mobile Image Protection
  function initMobileImageProtection() {
    document.addEventListener('contextmenu', function(e) {
      if (e.target.tagName === 'IMG' || e.target.closest('img')) {
        e.preventDefault();
        showWarning();
      }
    });

    document.addEventListener('touchstart', function(e) {
      if (e.touches.length > 1) {
        const target = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY);
        if (target && (target.tagName === 'IMG' || target.closest('img'))) {
          e.preventDefault();
        }
      }
    }, { passive: false });
  }

  // Mobile Context Menu
  function initMobileContextMenu() {
    document.addEventListener('contextmenu', function(e) {
      e.preventDefault();
      showWarning();
    });
  }

  // Background Image Protection
  function initBackgroundImageProtection() {
    const style = document.createElement('style');
    style.id = 'ah-bg-protection';
    style.textContent = `
      * {
        -webkit-user-drag: none !important;
        user-drag: none !important;
      }
      [style*="background-image"] {
        -webkit-touch-callout: none !important;
      }
    `;
    document.head.appendChild(style);

    document.addEventListener('dragover', function(e) {
      const target = e.target;
      if (target.style && target.style.backgroundImage) {
        e.preventDefault();
        return false;
      }
    });
  }

  // Right Click Protection
  function initRightClickProtection() {
    document.addEventListener('contextmenu', function(e) {
      const whitelist = ['INPUT', 'TEXTAREA', 'SELECT', 'A', 'BUTTON'];
      if (whitelist.includes(e.target.tagName)) return;
      e.preventDefault();
      showWarning();
    });
  }

  // Keyboard Shortcuts Protection
  function initShortcutProtection() {
    const blockedCombos = [
      { key: 'c', ctrl: true },
      { key: 'v', ctrl: true },
      { key: 's', ctrl: true },
      { key: 'a', ctrl: true },
      { key: 'u', ctrl: true },
      { key: 'p', ctrl: true },
      { key: 'c', meta: true },
      { key: 'v', meta: true },
      { key: 's', meta: true },
      { key: 'a', meta: true },
      { key: 'p', meta: true }
    ];

    document.addEventListener('keydown', function(e) {
      const target = e.target;
      if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT') return;
      if (target.isContentEditable) return;
      if (target.closest('[contenteditable="true"]')) return;

      const key = e.key.toLowerCase();
      const ctrl = e.ctrlKey || e.metaKey;

      for (const combo of blockedCombos) {
        if (combo.key === key && ((combo.ctrl && ctrl) || (combo.meta && e.metaKey))) {
          e.preventDefault();
          showWarning('Copying content is not allowed.');
          return;
        }
      }

      if (key === 'f12') {
        e.preventDefault();
        showWarning();
      }

      if (ctrl && key === 'shift' && (e.keyCode === 73 || e.keyCode === 74)) {
        e.preventDefault();
        showWarning('Developer tools access is restricted.');
      }
    });
  }

  // Console Notice
  function initConsoleNotice() {
    const style = document.createElement('style');
    style.id = 'ah-console-style';
    style.textContent = `
      body { position: relative; }
      body::before {
        content: 'Developer tools are disabled on this website.';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        background: #333;
        color: #fff;
        padding: 8px 16px;
        font-family: monospace;
        font-size: 12px;
        z-index: 2147483647;
        display: none;
      }
    `;
    document.head.appendChild(style);

    const consoleWarning = '⚠️ Developer tools are disabled. This action is not allowed.';

    Object.defineProperty(window, 'console', {
      value: {
        ...console,
        log: function() {
          console.__proto__.log.apply(console, arguments);
        },
        warn: function() {
          console.__proto__.warn.apply(console, arguments);
        },
        error: function() {
          showWarning('Console access is restricted.');
        }
      },
      writable: false,
      configurable: false
    });

    let devtoolsOpen = false;
    const threshold = 160;

    function checkDevTools() {
      const width = window.outerWidth - window.innerWidth;
      const height = window.outerHeight - window.innerHeight;

      if ((width > threshold || height > threshold) && !devtoolsOpen) {
        devtoolsOpen = true;
        showWarning('Developer tools are not allowed.');
      } else if (width <= threshold && height <= threshold) {
        devtoolsOpen = false;
      }
    }

    setInterval(checkDevTools, 1000);
  }

  // Print Protection
  function initPrintProtection() {
    window.addEventListener('beforeprint', function(e) {
      e.preventDefault();
      showWarning('Printing is disabled on this website.');
    });

    const printStyle = document.createElement('style');
    printStyle.id = 'ah-print-protection';
    printStyle.textContent = `
      @media print {
        * { display: none !important; }
        body::after {
          content: 'Printing is disabled. Please respect copyright.';
          display: block !important;
          padding: 50px;
          text-align: center;
          font-size: 24px;
          color: #333;
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    `;
    document.head.appendChild(printStyle);
  }

  // Protect dynamically added elements
  function observeNewElements() {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType !== 1) return;

          if (node.tagName === 'IMG') {
            protectNewImage(node);
          }

          const imgs = node.querySelectorAll ? node.querySelectorAll('img') : [];
          imgs.forEach(protectNewImage);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function protectNewImage(img) {
    img.addEventListener('contextmenu', function(e) {
      e.preventDefault();
      showWarning();
    });

    img.addEventListener('dragstart', function(e) {
      e.preventDefault();
      return false;
    });

    img.style.pointerEvents = 'auto';
  }

  observeNewElements();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
